var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwoSideArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 11,
    viewBox: "0 0 82 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87356 0.292893C7.26408 0.683417 7.26408 1.31658 6.87356 1.70711L4.58066 4L78.0306 4.00001L75.7934 1.76288C75.4029 1.37236 75.4029 0.739192 75.7934 0.348669C76.184 -0.0418562 76.8171 -0.0418561 77.2077 0.348669L81.4854 4.62645C81.876 5.01697 81.876 5.65014 81.4854 6.04066L77.2077 10.3184C76.8171 10.709 76.184 10.709 75.7934 10.3184C75.4029 9.92791 75.4029 9.29475 75.7934 8.90422L78.6977 6.00001L4.02511 6L6.87356 8.84845C7.26408 9.23897 7.26408 9.87214 6.87356 10.2627C6.48303 10.6532 5.84987 10.6532 5.45934 10.2627L1.18157 5.98488C0.791041 5.59436 0.791041 4.9612 1.18157 4.57067L5.45934 0.292893C5.84987 -0.0976311 6.48303 -0.0976311 6.87356 0.292893Z",
    fill: "url(#paint0_linear_385_2652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_2652",
    x1: 1,
    y1: 5,
    x2: 82,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8567FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSideArrow);
export default __webpack_public_path__ + "static/media/two_side_arrow.723535d8851f214465eed98a1085f86b.svg";
export { ForwardRef as ReactComponent };